import Button from '@atoms/Button';
import Container from '@atoms/Container';
import { twJoin } from 'tailwind-merge';
import ghosty from './assets/ghosty.webp';

/**
 * TODO: Write JSDocs.
 */
function NotFound() {
  return (
    <Container className={twJoin('flex flex-col', 'md:-mt-16 md:flex-row md:gap-40')}>
      <h2 className={twJoin('text-h4 font-semibold', 'md:hidden')}>
        Oops - looks like you got a little lost.
      </h2>
      <div className={twJoin('flex-1', 'md:order-3')}>
        <img alt="Ghosty" src={ghosty} />
      </div>
      <div className="flex flex-1 flex-col justify-center gap-5">
        <h2 className={twJoin('hidden text-h3 font-semibold', 'md:block')}>
          Oops - looks like you got a little lost.
        </h2>
        <p className="text-base">All good. It happens to the best of us.</p>
        <p className="text-base">
          Let&apos;s get you back on track before Ghosty here starts up a conversation. If
          you&apos;re still a little lost, check out one of our latest website themes
        </p>
        <Button asAnchor to="/" className="sm:w-fit">
          View Our Themes
        </Button>
      </div>
    </Container>
  );
}

export default NotFound;
